import React, { useState } from 'react';
import { Timer } from 'lucide-react';
import { MobileSelect } from '../ui/MobileSelect';
import {
  AUTO_SAVE_SECONDS_OPTIONS,
  loadQuickTagAutoSave,
  saveQuickTagAutoSave,
  type QuickTagAutoSave,
} from '../games/tennis/scoring/scoringPreferences';

/** Tennis-only: how the post-point tag drawer on the live scoring pad behaves on this device. */
export const TennisScoringSettingsSection: React.FC = () => {
  const [autoSave, setAutoSave] = useState<QuickTagAutoSave>(loadQuickTagAutoSave);

  const update = (next: QuickTagAutoSave) => {
    setAutoSave(next);
    saveQuickTagAutoSave(next);
  };

  return (
    <div className="space-y-3">
      <div className="bg-secondary-hover rounded-xl p-3">
        <label htmlFor="tennis-autosave-enabled" className="flex items-start space-x-3 cursor-pointer">
          <input
            id="tennis-autosave-enabled"
            type="checkbox"
            className="mt-1 rounded border-gray-300 text-primary focus:ring-primary"
            checked={autoSave.enabled}
            onChange={(e) => update({ ...autoSave, enabled: e.target.checked })}
          />
          <div className="flex-1">
            <div className="flex items-center">
              <Timer className="h-4 w-4 mr-2 text-primary" />
              <span className="font-medium text-dark">Auto-save point tags</span>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              After you score a point, the tag drawer saves and closes on its own if you don't tap anything. Turn this off to
              always close it yourself with Save or Skip.
            </p>
          </div>
        </label>
      </div>

      <div>
        <label className="form-label" htmlFor="tennis-autosave-seconds">
          Auto-save after
        </label>
        <MobileSelect
          id="tennis-autosave-seconds"
          disabled={!autoSave.enabled}
          value={String(autoSave.seconds)}
          onChange={(v) => update({ ...autoSave, seconds: Number(v) })}
          options={AUTO_SAVE_SECONDS_OPTIONS.map((s) => ({ value: String(s), label: `${s} seconds` }))}
          className={`w-full p-2 border border-stone rounded ${autoSave.enabled ? '' : 'opacity-50'}`}
          aria-label="Auto-save after"
          sheetTitle="Auto-save after"
        />
        <p className="text-xs text-gray-500 mt-1">Saved on this device.</p>
      </div>
    </div>
  );
};

export default TennisScoringSettingsSection;
